import { useEffect, useState } from "react";
import { getAllServiceAndApplications } from "../utils/service";
import ServicesCard from "./ServicesCard";
import SearchBar from "./form/SearchBar";
import CategorySelect from "./form/CategorySelect";

const ApplicationsSection = ({vocabId, delta}) => {
    const applicationsPerPage = delta || 6;

    const [page, setPage] = useState(1);
    const [applications, setApplications] = useState([]);
    const [totalApplications, setTotalApplications] = useState(0);
    const [searchKeyword, setSearchKeyword] = useState(null);
    const [filterCategoryId, setFilterCategoryId] = useState("");
    const [filterCategoryLbl, setFilterCategoryLbl] = useState("");

    useEffect(() => {
        fetchApplicationAndServices(searchKeyword, filterCategoryId, page, applicationsPerPage, page === 1);
    }, [page, searchKeyword, filterCategoryId]);

    const handleLoadMore = () => {
        let newPage = page + 1;
        setPage(newPage);
    };

    const handleSearch = (keyword) => {
        setSearchKeyword(keyword);
        setPage(1);
    };

    const handleCategoryChange = (categoryId, categoryLbl) => {
        setFilterCategoryId(categoryId);
        setFilterCategoryLbl(categoryLbl);
        setPage(1);
    };

    const fetchApplicationAndServices = async (searchKeyword, filterCategoryId, page, applicationsPerPage) => {
        const data = await getAllServiceAndApplications(searchKeyword, filterCategoryId, page, applicationsPerPage);
        if (page == 1) {
            setApplications(data.items || []);
        } else {
            setApplications((prev) => [...prev, ...(data.items || [])]);
        }
        setTotalApplications(data.totalCount);
    };

    return (
        <div className="">
            <div className="row service-filters">
                <SearchBar onSearch={handleSearch} />
                <CategorySelect
                    categoryLbl={filterCategoryLbl}
                    vocabId={vocabId}
                    onChange={handleCategoryChange} />
            </div>

            <div className="row applications-grid">
                {
                    applications.length > 0 ? (
                        <>
                            {applications.map((application) => (
                                <ServicesCard key={application.id} application={application} />
                            ))}
                        </>
                    ) : (
                        <div className="d-flex align-items-center justify-content-center p-5 w-100">{"No application found."}</div>
                    )
                }
                
            </div>

            {applications.length < totalApplications && (
                <div className="row load-more-container pb-0">
                    <button className="load-more" onClick={handleLoadMore}>
                        <div className="text">{`${Liferay.Language.get("dwtc.load.more")}`}</div>
                        <div className="icon-reload"></div>
                    </button>
                </div>
            )}
        </div>
    );
};

export default ApplicationsSection;